import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, reactive, onMounted } from 'vue';
import { getPolicy } from "@/api/common.js"
import { ElMessage } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'policyDialog',
  props: {
    popupShow: {
        type: Boolean,
        default: false
    }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props
const info = ref('')
const dialogShow = ref(props.popupShow)
const emitList = __emit

function getInfo() {
    getPolicy().then(res => {
        info.value = res.data.agreementContent;
    })
}
function closeEvent() {
    emitList('close')
}

onMounted(() => {
    getInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogShow).value = $event)),
    width: "70%",
    center: "",
    onClose: closeEvent
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        innerHTML: info.value,
        style: {"max-height":"70vh","overflow-y":"auto"}
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})